// Libraries
import { Component } from '@angular/core';

/**
 * `AppAdminComponent` implements the main view for admin module.
 */
@Component({
  template: require('./app-admin.component.html')
})
export class AppAdminComponent {
  /**
   * Creates a new `AppAdminComponent` instance.
   */
  constructor(
  ) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/app-admin.component.ts